(function () {
  const viewTransitionRenderBlocker =
    document.getElementById('view-transition-render-blocker');

  /*
   * PERFORMANCE FIX:
   * Do not hold back the initial page render.
   *
   * Page transitions still work for navigation through the
   * pageswap and pagereveal handlers below.
   */
  viewTransitionRenderBlocker?.remove();

  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    /*
     * Cancel the transition when the visitor interacts,
     * helping interaction responsiveness.
     */
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    /*
     * Remove inactive transition types to prevent duplicate
     * transition names on product media.
     */
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])'
      )
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered =
      document.querySelector('[data-view-transition-triggered]');

    const transitionType =
      transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);

      sessionStorage.setItem(
        'custom-transition-type',
        transitionType
      );
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    const customTransitionType =
      sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');

        document
          .querySelectorAll('[data-view-transition-type]')
          .forEach((element) => {
            element.removeAttribute('data-view-transition-type');
          });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    return (
      typeof ViewTransition === 'undefined' ||
      !(viewTransition instanceof ViewTransition) ||
      isLowPowerDevice()
    );
  }

  /*
   * Keep this logic synchronized with utilities.js.
   */
  function isLowPowerDevice() {
    return (
      Number(navigator.hardwareConcurrency) <= 2 ||
      Number(navigator.deviceMemory) <= 2
    );
  }
})();